/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quote-sent': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<g _stroke="#7CB774" _fill="none" fill-rule="evenodd" stroke-linecap="square" stroke-linejoin="bevel"><path pid="0" d="M3.966 1.785c.536 1.654-.279 2.848-2.444 3.58l2.626 1.99M1.084 1.357h4.815M6.604 4.478h3.704M8.456 2.626V6.33"/></g>'
  }
})
